import Http from '@/classes/http/Http'

export default {
  getAuditors (filter) {
    return Http.get({
      url: `auditors${filter}`
    })
  },
  getAuditorsExcel (filter, sheetName) {
    return Http.download({
      url: `auditors/downloads/${sheetName}/${filter}`
    })
  }
}
